<template>
    <stylish-table :table="partnersTable">
        <template slot="htmlContent" slot-scope="{ cell }">
            <svg
                v-if="cell.content"
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                ></path>
            </svg>
            <svg
                v-else
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 12H4"
                ></path>
            </svg>
        </template>
        ></stylish-table
    >
</template>

<script>
import StylishTable from "./StylishTable";
export default {
    components: {
        StylishTable
    },
    props: {
        partners: {
            type: Array,
            required: true
        }
    },
    computed: {
        partnersTable() {
            const partnersTable = { headers: ["Associé", "Gérance", "Parts"] };
            partnersTable.data = this.partners.map(partner => [
                partner.name,
                partner.isManager,
                partner.percentage + "%"
            ]);
            return partnersTable;
        }
    }
};
</script>

<style></style>
